import * as React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import Grid from '@mui/material/Grid2'
import { Avatar } from 'components/UI'
// view components
import Search from 'components/PageComponents/Home/components/DashboardWidgets/components/StrategyActions/components/Content/components/FiltersPanel/components/Search'
// views
import { CategoryTitle, InnerWrapper, Option, OptionWrapper, Wrapper } from './view'
import { CheckedIcon } from 'components/Modals/SystemProcessModal/Form/components/Transactions/components/Transaction/components/SendEmail/components/Recipients/components/RecipientSelect/view'
// constants
import { Forms } from 'constants/forms'
// context
import { ObjectsBLContext } from 'containers/ObjectsAndProperties/Edit/layers/BL'
// types
import { IPlanType } from 'types/graphql'
// utils
import get from 'lodash/get'

interface IIncomingProps {
  planTypes: IPlanType[]
}

const PlanTypesFilter: React.FunctionComponent<IIncomingProps & InjectedFormProps> = ({ planTypes }) => {
  const { selectedPlanType } = React.useContext(ObjectsBLContext)

  const router = useRouter()

  const selectPlanType = (planType: IPlanType) => {
    router.push(
      {
        pathname: `/settings/objects/${router.query.id}`,
        query: {
          planType: planType.id
        }
      },
      undefined,
      { shallow: true }
    )
  }

  return (
    <Wrapper container direction={'column'}>
      <Search name={'planType'} />
      <CategoryTitle>PLAN TYPES</CategoryTitle>
      <InnerWrapper>
        <Grid container direction={'column'} style={{ paddingRight: 12 }}>
          {planTypes.map((planType) => (
            <OptionWrapper key={planType.id}>
              <Avatar user={planType} />
              <Option onClick={() => selectPlanType(planType)}>{planType.description}</Option>
              {planType.id === get(selectedPlanType, 'id') && <CheckedIcon />}
            </OptionWrapper>
          ))}
        </Grid>
      </InnerWrapper>
    </Wrapper>
  )
}

export default reduxForm<any, any>({ form: Forms.PLAN_TYPES_FILTER_FORM })(PlanTypesFilter)
